import { PhoneCountryCodeType } from '@bus/models';
import { CorrespondenceMethodEnum } from '../../../types/forms';
import { TradingDetailsServicePlanBusinessFormModel_MX } from './formModel';

export const tradingDetailsInitialValues: TradingDetailsServicePlanBusinessFormModel_MX = {
  tradingAs: undefined,
  legalName: undefined,
  vatLiable: undefined,
  vatNumber: undefined,
  croNumber: undefined,
  correspondenceMethod: CorrespondenceMethodEnum.email,
  email: undefined,
  countryCode: PhoneCountryCodeType.Ireland,
  mobileNumber: undefined,
};
